<template>
	<div class="baselayout-bar">
		<Header />
		<Sidebar />
		<div class="page-content">
			<router-view />
		</div>
	</div>
</template>
<script>
import Sidebar from '../components/TheSidebar/';
import Header from '../components/TheHeader/';
export default {
	components: {
		Sidebar,
		Header
	}
};
</script>
